// extracted by mini-css-extract-plugin
export default {"description":"PasswordRecoveryForm_description__d5Kq5"};